import { BiPlus } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import Visacostsunmodule from "./visacostsubmodule";
import VisacosttableModule from "./visacostTableModule";
import { useDispatch } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import React, { useEffect, useRef, useState } from "react";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import CostplusInvoice from "../../DummyPdfs/Pdf2Components/costPlusInvoicePDF";
import { PDFDownloadLink } from "@react-pdf/renderer";
import SecDeposite from "../../DummyPdfs/visacostSecdepositePDF/SecdepositePDF";

export default function VisaCostedit({ propData, quotationType,SetDownloadPDF,setData1,setData2 }) {
  console.log("propDATA........to be seen here.", propData);
  const dispatch = useDispatch();

  const row = [
    {
      id: 1,
      name: "YTC",
    },
  ];
  const rowsData = [
    {
      id: 1,
      name: "YTC",
    },
    {
      id: 2,
      name: "YTC",
    },
    {
      id: 3,
      name: "YTC",
    },
    {
      id: 4,
      name: "YTC",
    },
    {
      id: 4,
      name: "YTC",
    },
  ];
  const tableHeading = [
    {
      rate_category_id: 1,
      title: "EMPLOYEE SALARY PACKAGE",
      bgPrimary: "bg-orange-400",
      bgSecondary: "bg-orange-200",
    },
  ];
  const tableProperties = {
    colWidth: "w-56",
    colHeight: "h-[3rem]",
    itemHeight: "h-[4rem]",
  };
  console.log("propData....mmmmm", propData);
  const token = localStorage.getItem("nodeToken");

  const [responseData, setResponseData] = useState();

  const response = async () => {
    try {
      const data = await nodeinstance.get(
        `/dashboard/visaSecurity/${propData?.id}/${quotationType}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (data.status === 200) {
        console.log("data to be seen here.....", data);
        setResponseData(data?.data?.data);
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };
  const [professions, setProfessions] = useState();
  const professionData = async () => {
    try {
      const response = await nodeinstance.get(
        "/dashboard/localTransfer/getProfessions",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setProfessions(response?.data.data);
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };

  console.log("responseData...responseData", responseData);
  const createDefaultRow = (index) => {
    return {
      id: index + 1,
      actual_professionId: "",
      visa_professionId: "",
      profession_level: "",
      gender: "",
      nationality: "",
      quantity: "",
      basic: "",
      food: "",
      fixed_ot: "",
      hra: "",
      travel_allowance: "",
      mobile_allowance: "",
      additional_ot: "",
      other_allowance: "",
    };
  };
  const [rowData, setRowsData] = useState(() => {
    const initialRows = [];
    for (let i = 0; i < 1; i++) {
      initialRows.push({ id: i + 1, ...createDefaultRow() });
    }
    return initialRows;
  });
  const handleRemoveRow = (idToRemove) => {
    console.log("idToRemove......idToRemove", idToRemove);
    const updatedTableData = rowData.filter((row) => row.id !== idToRemove);
    setRowsData(updatedTableData);
  };

  const handleChange = (event, index) => {
    const { name, value } = event.target;
    const updatedRowsData = [...rowsData];
    updatedRowsData[index] = {
      ...updatedRowsData[index], // Copy existing properties
      [name]: value,
      date: getDatevalue(),
    };
    setRowsData(updatedRowsData);
  };

  const handleAddRow = () => {
    setRowsData((prevRowsData) => [
      ...prevRowsData,
      {
        id: prevRowsData.length + 1,
        actual_professionId: "",
        visa_professionId: "",
        profession_level: "",
        gender: "",
        nationality: "",
        quantity: "",
        basic: "",
        food: "",
        fixed_ot: "",
        hra: "",
        travel_allowance: "",
        mobile_allowance: "",
        additional_ot: "",
        other_allowance: "",
      },
    ]);
  };

  useEffect(() => {
    response();
    professionData();
  }, [propData]);

  useEffect(() => {
    const mappedData =
      responseData &&
      responseData?.map((serverData, index) => {
        return {
          ...createDefaultRow(index),
          ...serverData,
        };
      });
    console.log("mappedDatamappedData", mappedData?.length);
    // Set the mapped data into the rowsData state variable
    if (mappedData && mappedData?.length > 0) {
      setRowsData(mappedData);
    }
  }, [responseData]);
  console.log("data to be seen here.......12345678", rowData);
  const [selectedValue, setSelectedValue] = useState([]);
  const [summaryData, setSummaryData] = useState();
  const [trigger, setTrigger] = useState(false);
  const [excelDownload, setExcelDownload] = useState(false);

  const downloadFile = async () => {
    setExcelDownload(true);
    try {
      const response = await nodeinstance.get(
        `/dashboard/visaSecurity/downloadReport/${propData?.id}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Visa-cost-security-deposite-report`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setExcelDownload(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setExcelDownload(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  console.log("response to be seen here.......", rowData);
  useEffect(() => {
    dispatch(
      setBreadCrumb([
        {
          label: "VISA COST AND SECURITY DEPOSIT",
          link: "/dashboard/visa-cost-&-sec-deposit",
        },
        {
          label: `${responseData && responseData[0]?.contract_number}`,
          link: "/dashboard/visa-cost-&-sec-deposit",
        },
      ])
    );
  }, [location, rowData]);

  const [selectedId, setSelectedId] = useState([]);

  const downloadButtonRef = useRef(null);

  const [costPlusInvoiceDownload, setCostPlusInvoiceDownload] = useState(false);

  const [data, setData] = useState();
  

  useEffect(() => {
    if (selectedId.length <= 0) {
      return;
    } else {
      // proformaInvoiceData(selectedId);
    }
  }, [selectedId]);

  const [pdfLoading, setPdfloading] = useState(false);

  const [secDeposite, setSecDeposite] = useState(false);
  const [secLoading, setSecloading] = useState(false);

  const handleSecDeposite = () => {
    if (selectedId === undefined || selectedId === null) {
      alert("Error: No selected ID.");
      return;
    } else if (data && data.length <= 0) {
      setTimeout(() => {
        setSecloading(false);
        setSecDeposite(true);
      }, 5000);
    } else {
      setSecloading(false);
      setSecDeposite(false);
    }
  };

  const handleDownloadClick = async () => {
    if (selectedId === undefined || selectedId === null) {
      alert("Error: No selected ID.");
      return;
    } else if (data && data.length <= 0) {
      setTimeout(() => {
        setPdfloading(false);
        setCostPlusInvoiceDownload(true);
      }, 5000);
    } else {
      setPdfloading(false);
      setCostPlusInvoiceDownload(false);
    }
  };

  console.log("sselectedIdelectedId....", rowData);

  const [selectedData, setSelectedData] = useState([]);

  const handleCheckboxChange = (event, listData) => {
    const isChecked = event.target.checked;
    setSelectedData((prevState) => {
      if (isChecked) {
        if (!prevState.some((item) => item.id === listData.id)) {
          return [...prevState, listData];
        }
      } else {
        return prevState.filter((item) => item.id !== listData.id);
      }
      return prevState;
    });
  };

  console.log("selectedData...selectedData", row, rowData);

  return (
    <>
      {responseData?.length <= 0 ? (
        <LoadingWithLable className="col-span-11" />
      ) : (
        <div className="pt-2 uppercase m-3">
          {/* <div className="flex flex-wrap  gap-2 w-full items-center "> */}
          <div className="flex flex-wrap gap-2 mb-1 items-center">
            <button
              className="p-2 bg-red text-white rounded-md"
              style={{ width: "200px" }}
              // onClick={handlecreateVRFroute}
            >
              IMMEDIATE
            </button>
          </div>
          <div className="flex flex-wrap gap-2 mb-1 items-center">
            <p
              style={{ fontWeight: "bold", fontSize: "15px" }}
              className="ml-5"
            >
              cost sheet: {quotationType ? quotationType : ""}
            </p>
            <div className="ml-auto flex gap-2">
              <div className="relative">
                <div className="peer">
                  <button className="flex items-center gap-2 bg-blue text-white p-2 px-3  rounded-md w-fit text-xs text-center ">
                    Download
                  </button>
                </div>
                <div
                  className={
                    "hidden absolute -top-[1.5rem] transform -translate-x-1/2 max-w-xs w-[14rem] h-auto bg-white shadow-xl rounded-lg p-2 ring-1 ring-slate-400  peer-hover:flex hover:flex flex-col gap-2"
                  }
                >
                  <button
                    className="flex justify-center items-center gap-2 ring-1 ring-slate-300 shadow-sm font-semibold text-black bg-slate-50 p-2 px-3 rounded-md w-full text-xs text-center  disabled:bg-slate-300 disabled:cursor-not-allowed hover:bg-blue hover:text-white disabled:hover:text-black"
                    onClick={() => {
                      downloadFile();
                    }}
                  >
                    DOWNLOAD REPORT
                  </button>
                  {/* <button
                    className="flex justify-center items-center gap-2 ring-1 ring-slate-300 shadow-sm font-semibold text-black bg-slate-50 p-2 px-3 rounded-md w-full text-xs text-center disabled:bg-slate-300 disabled:cursor-not-allowed hover:bg-blue hover:text-white disabled:hover:text-black"
                    onClick={() => {
                      downloadPaymentReceipt();
                    }}
                  >
                    DOWNLOAD INVOICE
                  </button> */}
                </div>
              </div>
            </div>
          </div>
          {rowData?.length <= 0 ? (
            "No data found"
          ) : (
            <div className="!uppercase">
              <div
                className="flex flex-col w-full gap-1 my-2 overflow-x-scroll pl-16 pt-8"
                style={rowData.length > 4 ? { height: "250px" } : {}}
              >
                <div className="flex">
                  {row.map((section, sectionIndex) => (
                    <div className="flex flex-col relative" key={sectionIndex}>
                      {sectionIndex == 0 && (
                        <>
                          <div
                            className={`w-full text-white py-2  ${tableHeading[sectionIndex].bgPrimary}`}
                          >
                            <h2 className="text-center">
                              {/* {tableHeading[sectionIndex].title} */}
                              {"EMPLOYEE SALARY PACKAGE"}
                            </h2>
                          </div>
                          <div className={`flex w-full gap-1 `}>
                            <>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                              >
                                SELECT
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                              >
                                SL. NO.
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                              >
                                ACTUAL PROFESSION
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                              >
                                VISA PROFESSION
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                              >
                                PROFESSION LEVEL
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                              >
                                GENDER
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                              >
                                NATIONALITY
                              </h3>
                              <h3
                                className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                              >
                                QUANTITY
                              </h3>
                              {quotationType === "Cost Plus" ? (
                                rowData &&
                                rowData[sectionIndex]?.quotation_details?.map(
                                  (data, index) => (
                                    <h3
                                      className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                      key={index}
                                    >
                                      {data.quotation_heading_name}
                                    </h3>
                                  )
                                )
                              ) : (
                                <>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    BASIC
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    FOOD
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    FIXED OT
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    HRA
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    TRAVEL ALLOWANCE
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    MOBILE ALLOWANCE
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    AIR TICKET ALLOWANCE
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    ADDITIONAL OT
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    OTHER ALLOWANCE
                                  </h3>
                                </>
                              )}
                            </>
                          </div>
                        </>
                      )}
                      <div className="mb-2">
                        {rowData?.map((data, index) => (
                          <div
                            className="flex w-full gap-1 relative mb-2 mt-2"
                            key={index}
                          >
                            {/* <div className="flex gap-1 absolute -left-16">
                            <button
                              type="button"
                              className=" p-1 rounded-md ring-1 ring-slate-300"
                              onClick={handleAddRow}
                            >
                              <BiPlus size={"1.2rem"} />
                            </button>
                          </div>
                          <button
                            type="button"
                            className="bg-red text-white p-1 rounded-md ring-1 ring-red absolute -left-8"
                            onClick={() => handleRemoveRow(data.id)}
                          >
                            <MdDeleteOutline size={"1.2rem"} />
                          </button> */}
                            <p
                              className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            >
                              <input
                                key={data.id}
                                type="checkbox"
                                checked={selectedData.some(
                                  (item) => item.id === data.id
                                )}
                                onChange={(event) =>
                                  handleCheckboxChange(event, data)
                                }
                              />
                            </p>

                            <p
                              className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            >
                              {index + 1}
                            </p>
                            <p
                              className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            >
                              {/* {data.name} */}
                              <select
                                className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                value={data?.actual_professionId}
                                // onChange={handleVisaChange}
                              >
                                <option>{"select value"}</option>
                                {professions?.Actualprofessions?.map(
                                  (data, index) => (
                                    <React.Fragment key={index}>
                                      <option value={data.id}>
                                        {data.name}
                                      </option>
                                    </React.Fragment>
                                  )
                                )}
                              </select>
                            </p>
                            <p
                              className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            >
                              <select
                                className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                value={data?.visa_professionId}
                                // onChange={handleVisaChange}
                              >
                                <option>{"select value"}</option>
                                {professions?.visaProfessions?.map(
                                  (data, index) => (
                                    <React.Fragment key={index}>
                                      <option value={data.id}>
                                        {data.name}
                                      </option>
                                    </React.Fragment>
                                  )
                                )}
                              </select>
                            </p>
                            <p
                              className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            >
                              {data.profession_level}
                            </p>
                            <p
                              className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            >
                              {data.gender}
                            </p>
                            <p
                              className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            >
                              {data.nationality}
                            </p>
                            <p
                              className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            >
                              {data.quantity}
                            </p>
                            {quotationType === "Cost Plus" ? (
                              data?.quotation_details?.map(
                                (filterData, index) => (
                                  <h3
                                    className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                    key={index}
                                  >
                                    {filterData.cost}
                                  </h3>
                                )
                              )
                            ) : (
                              <>
                                <p
                                  className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                >
                                  {quotationType === "Cost Plus"
                                    ? "NA"
                                    : data.basic}
                                </p>
                                <p
                                  className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                >
                                  {quotationType === "Cost Plus"
                                    ? "NA"
                                    : data.food}
                                </p>
                                <p
                                  className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                >
                                  {quotationType === "Cost Plus"
                                    ? "NA"
                                    : data.fixed_ot}
                                </p>
                                <p
                                  className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                >
                                  {quotationType === "Cost Plus"
                                    ? "NA"
                                    : data.hra}
                                </p>
                                <p
                                  className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                >
                                  {quotationType === "Cost Plus"
                                    ? "NA"
                                    : data.travel_allowance}
                                </p>
                                <p
                                  className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                >
                                  {quotationType === "Cost Plus"
                                    ? "NA"
                                    : data.mobile_allowance}
                                </p>
                                <p
                                  className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                >
                                  {quotationType === "Cost Plus"
                                    ? "NA"
                                    : data.air_ticket_allowance}
                                </p>
                                <p
                                  className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                >
                                  {quotationType === "Cost Plus"
                                    ? "NA"
                                    : data.additional_ot}
                                </p>
                                <p
                                  className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                >
                                  {quotationType === "Cost Plus"
                                    ? "NA"
                                    : data.other_allowance}
                                </p>
                              </>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
          <div>
            <Visacostsunmodule
              propData={selectedData}
              Qunatity={rowData}
              quotationType={quotationType}
              contractId={propData}
              setSummaryData={setSummaryData}
              trigger={trigger}
              contractNumber={responseData && responseData[0]?.contract_number}
              setSelectedData={setSelectedData}
            />
          </div>
          <div>
            <VisacosttableModule
              summaryData={summaryData}
              propData={rowData}
              setTrigger={setTrigger}
              setSelectedId={setSelectedId}
              selectedId={selectedId}
              quotationType={quotationType}
              trigger={trigger}
              setSelectedValue={setSelectedValue}
              SetDownloadPDF={SetDownloadPDF}
              setData1 = {setData1}
              setData2 = {setData2}
            />
          </div>
        </div>
      )}
    </>
  );
}
